type TripWidget =
	| TripWidgetTaskCounter
	| TripWidgetTravelerCounter
	| TripWidgetDocumentCounter
	| TripWidgetWallPinCounter
	| TripWidgetSpotCounter
	| TripWidgetItineraryCounter
	| TripWidgetStore

enum TRIP_WIDGET_TYPE {
	TASK_COUNTER = 'taskCounter',
	SPOT_COUNTER = 'spotCounter',
	TRAVELER_COUNTER = 'travelerCounter',
	DOCUMENT_COUNTER = 'documentCounter',
	WALL_PIN_COUNTER = 'wallPinCounter',
	ITINERARY_COUNTER = 'itineraryCounter',
	STORE = 'store',
}

type TripWidgetTaskCounter = {
	type: TRIP_WIDGET_TYPE.TASK_COUNTER
	data: TripWidgetCounterData & {
		todo: number
		doing: number
		done: number
	}
}

type TripWidgetTravelerCounter = {
	type: TRIP_WIDGET_TYPE.TRAVELER_COUNTER
	data: TripWidgetCounterData & TripWidgetPictureData
}

type TripWidgetDocumentCounter = {
	type: TRIP_WIDGET_TYPE.DOCUMENT_COUNTER
	data: TripWidgetCounterData
}

type TripWidgetWallPinCounter = {
	type: TRIP_WIDGET_TYPE.WALL_PIN_COUNTER
	data: TripWidgetCounterData
}

type TripWidgetSpotCounter = {
	type: TRIP_WIDGET_TYPE.SPOT_COUNTER
	data: TripWidgetCounterData & TripWidgetPictureData
}

type TripWidgetItineraryCounter = {
	type: TRIP_WIDGET_TYPE.ITINERARY_COUNTER
	data: TripWidgetCounterData & TripWidgetDatesData
}

type TripWidgetCounterData = {
	total: number
}

type TripWidgetPictureData = {
	pictureUrls: string[]
}

type TripWidgetDatesData = {
	startDate?: Date
	endDate?: Date
}

type TripWidgetStore = {
	type: TRIP_WIDGET_TYPE.STORE
	data: {
		indispensables: boolean
		activities: boolean
		ideas: boolean
	}
}

export {
	TripWidget,
	TRIP_WIDGET_TYPE,
	TripWidgetTaskCounter,
	TripWidgetTravelerCounter,
	TripWidgetDocumentCounter,
	TripWidgetSpotCounter,
	TripWidgetWallPinCounter,
	TripWidgetItineraryCounter,
	TripWidgetStore,
}
